import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

/**
 * Lyrics-first visualizer: soft spectrum floor + room for karaoke overlay.
 * Overlay is drawn by main/offline after this.
 */
export const lyricsViz: Visualizer = {
  id: 'lyrics',
  label: 'Lyrics Stage',
  draw(frame) {
    const { ctx, w, h, bands, freq, t } = frame;
    clearBg(ctx, w, h, 1);

    // deep gradient
    const bg = ctx.createLinearGradient(0, 0, 0, h);
    bg.addColorStop(0, '#070d14');
    bg.addColorStop(0.55, '#0a1520');
    bg.addColorStop(1, '#061018');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, w, h);

    // ambient orbs
    const cx = w * 0.5;
    const cy = h * 0.38;
    const orb = ctx.createRadialGradient(
      cx,
      cy,
      10,
      cx,
      cy,
      Math.min(w, h) * (0.28 + bands.energy * 0.08),
    );
    orb.addColorStop(0, `rgba(86,240,200,${0.12 + bands.kick * 0.1})`);
    orb.addColorStop(0.5, `rgba(40,120,160,${0.08 + bands.mids * 0.06})`);
    orb.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = orb;
    ctx.fillRect(0, 0, w, h);

    // floor spectrum
    const n = Math.min(64, freq.length);
    const baseY = h * 0.88;
    const barMax = h * 0.12;
    const totalW = w * 0.7;
    const x0 = (w - totalW) / 2;
    const bw = totalW / n;
    for (let i = 0; i < n; i++) {
      const bin = Math.floor((i / n) * (freq.length - 1));
      const v = freq[bin] / 255;
      const bh = Math.max(2, v * barMax * (0.6 + bands.bass * 0.5));
      ctx.fillStyle = `hsla(${170 + i * 1.2 + t * 4}, 80%, 55%, ${0.25 + v * 0.45})`;
      ctx.fillRect(x0 + i * bw, baseY - bh, bw * 0.7, bh);
    }

    // horizon line
    ctx.strokeStyle = `rgba(86,240,200,${0.15 + bands.energy * 0.2})`;
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(w * 0.12, h * 0.48);
    ctx.lineTo(w * 0.88, h * 0.48);
    ctx.stroke();

    drawHud(frame);
  },
};
